
import { AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { EmailDetailHeader } from './EmailDetailHeader';

interface EmailDetailErrorProps {
  folder: string | undefined;
  type: 'database' | 'not-found';
  onBack: () => void;
}

export const EmailDetailError = ({ folder, type, onBack }: EmailDetailErrorProps) => {
  const isDatabaseError = type === 'database';
  
  return (
    <div className="flex flex-col h-full">
      <EmailDetailHeader folder={folder} />
      
      <div className="flex-1 p-6 flex flex-col items-center justify-center">
        <Card className="max-w-md w-full">
          <CardContent className="pt-6 text-center">
            <AlertCircle className={`h-12 w-12 mx-auto mb-4 ${isDatabaseError ? 'text-destructive' : 'text-amber-500'}`} />
            <h2 className="text-xl font-semibold mb-2">
              {isDatabaseError ? 'Database Error' : 'Email Not Found'}
            </h2>
            <p className="text-muted-foreground mb-4">
              {isDatabaseError 
                ? 'There was an error connecting to the email database.'
                : "The email you're looking for doesn't exist or has been deleted."
              }
            </p>
            <Button variant="outline" onClick={onBack}>
              Return to Email List
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
